/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActualAssetClassExposureWeightsViewModel
 */
export interface ActualAssetClassExposureWeightsViewModel {
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    equity?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    property?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    bonds?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    cash?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    hedge?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    privateEquity?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    commodities?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureWeightsViewModel
     */
    other?: number;
}

/**
 * Check if a given object implements the ActualAssetClassExposureWeightsViewModel interface.
 */
export function instanceOfActualAssetClassExposureWeightsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ActualAssetClassExposureWeightsViewModelFromJSON(json: any): ActualAssetClassExposureWeightsViewModel {
    return ActualAssetClassExposureWeightsViewModelFromJSONTyped(json, false);
}

export function ActualAssetClassExposureWeightsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActualAssetClassExposureWeightsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'equity': !exists(json, 'Equity') ? undefined : json['Equity'],
        'property': !exists(json, 'Property') ? undefined : json['Property'],
        'bonds': !exists(json, 'Bonds') ? undefined : json['Bonds'],
        'cash': !exists(json, 'Cash') ? undefined : json['Cash'],
        'hedge': !exists(json, 'Hedge') ? undefined : json['Hedge'],
        'privateEquity': !exists(json, 'PrivateEquity') ? undefined : json['PrivateEquity'],
        'commodities': !exists(json, 'Commodities') ? undefined : json['Commodities'],
        'other': !exists(json, 'Other') ? undefined : json['Other'],
    };
}

export function ActualAssetClassExposureWeightsViewModelToJSON(value?: ActualAssetClassExposureWeightsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Percentage': value.percentage,
        'Equity': value.equity,
        'Property': value.property,
        'Bonds': value.bonds,
        'Cash': value.cash,
        'Hedge': value.hedge,
        'PrivateEquity': value.privateEquity,
        'Commodities': value.commodities,
        'Other': value.other,
    };
}

